<template>
  <div class="app-container">
    <router-view />
    <TabBar />
  </div>
</template>

<script>
import TabBar from '../gaAdmin/components/tabBar.vue';

export default {
  name: 'GAAdminLayout',
  components: {
    TabBar,
  },
};
</script>

<style scoped lang="scss">
.app-container {
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
</style>
